<template>
  <v-stepper-content v-bind="$attrs">
    <v-card>
      <v-card-title>
        Завершение
      </v-card-title>
      <v-card-text>
        <v-card v-if="master">
          <v-card-subtitle>
            Проверьте данные
          </v-card-subtitle>
          <v-card-text>
            <div style="line-height: 2em">
              <span style="color: #343434;">Дилер: </span> <span style="font-size: 1.3em; color: #343434">{{master.dealerName}}</span>
            </div>
            <div style="line-height: 2em">
              <span style="color: #343434;">Объект: </span> <span style="font-size: 1.3em; color: #343434">{{master.objectName}}</span>
            </div>
            <div style="line-height: 2em">
              <span style="color: #343434;">Модуль ПО: </span> <span style="font-size: 1.3em; color: #343434">{{master.moduleName}}</span>
            </div>
          </v-card-text>
        </v-card>
        <v-text-field
          class="mt-5"
          :value="value"
          @input="$emit('input', $event)"
          color="green"
          label="Введите название нового GSA"       
          autofocus   
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="$emit('back')"
          text
        >
          <v-icon small>mdi-arrow-left</v-icon>
          Назад
        </v-btn>

        <v-btn
          @click="$emit('next')"
          color="green"
          :disabled="!value"
          dark
        >
          <v-icon small>mdi-page-next-outline</v-icon>
          Создать новый GSA
        </v-btn>
        
        
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'master_id'],
  computed: {
    ...mapGetters(['masters']),
    master(){
      return this.masters.filter(el => (el.id == this.master_id) && !el.isDeleted)[0]
    }
  }
}
</script>